
import AuctionRequestManage from "@/views/auctionRequest/AuctionRequestManage";
import AuctionRequestEdit from "@/views/auctionRequest/AuctionRequestEdit";

const routes = [
 {
    path: '/AuctionRequest/List',
    name: 'AuctionRequestList',
    component: AuctionRequestManage,
    meta:{requiredAuth:true}
  },
 {
    path: '/AuctionRequest/Edit/:id',
    name: 'AuctionRequestEdit',
    component: AuctionRequestEdit,
    meta:{requiredAuth:true}
  },
]

export default routes